import React, { Component } from 'react';
import _ from 'lodash';
import { multiLanguage } from "../../hoc";
import data from '../../data/SanctuaryClub/privileges';
import ImagePlus from '../../components/ImagePlus';

@multiLanguage()
export default class Privileges extends Component {
  renderImage = () => {
    const allimage = data.imageContent;
    const { t } = this.props;
    return _.map(allimage, item => <ImagePlus src={item.thumbnail} title={t(item.title)} />)
  }
  render() {
    const { content } = data;
    const { t } = this.props;
    return (
      <div className="section3-privileges">
      <div className="content">
        <div className="title">
          <h2>{t(content.title)}</h2>
          <p dangerouslySetInnerHTML={{ __html: t(content.description) }} />
        </div>
        <div className="sub-title"><h3 dangerouslySetInnerHTML={{ __html: t(content.subTitle) }} /></div>
        <div className="bg-image">
          { this.renderImage() }
        </div>
      </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/SanctuaryClub/Privileges.js